import { render, staticRenderFns } from "./ScreeningDataInfoDetail.vue?vue&type=template&id=5481ca5b&scoped=true"
import script from "./ScreeningDataInfoDetail.vue?vue&type=script&lang=js"
export * from "./ScreeningDataInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./ScreeningDataInfoDetail.vue?vue&type=style&index=0&id=5481ca5b&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5481ca5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5481ca5b')) {
      api.createRecord('5481ca5b', component.options)
    } else {
      api.reload('5481ca5b', component.options)
    }
    module.hot.accept("./ScreeningDataInfoDetail.vue?vue&type=template&id=5481ca5b&scoped=true", function () {
      api.rerender('5481ca5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/screeningDataInfo/ScreeningDataInfoDetail.vue"
export default component.exports